import { formatValue } from "../../utils/helpers";

interface ImprovementsCardProps {
    num?: number;
    text: string;
    val?: string;
};

const ImprovementsCard = ({ num, text, val }: ImprovementsCardProps) => {
    
    return (
        <div className="bg-memphis-blue rounded-lg shadow-md max-w-[255px] h-52 flex flex-col items-center justify-center px-10">
            <span className="text-5xl font-bold text-memphis-yellow">{num}</span>
            <p className="text-white text-lg text-center">{text}</p>
            {val &&
                <p className="text-white text-lg">{`(${formatValue(val, 'currency')})`}</p>
            }
          
        </div>
    );
};

export default ImprovementsCard;